module.exports = __webpack_public_path__ + "static/media/hintergrund_sterne.0ca4b275.svg";